<template>
    <div>
        <div class="row">

            <div class="col-lg-9">

                <div class="card card-bordered">
                    <div class="card-inner">

                        <form-wizard title="" subtitle="" color="#6576ff" error-color="#e85347" shape="circle" activateAll>
                            <tab-content :title="translations.pilot" icon="ni ni-user">
                                <!-- Pilot -->
                                <div class="row gy-gs pb-3">
                                    <div class="col">
                                        <div class="nk-block-head nk-block-head-sm">
                                            <div class="nk-block-between">
                                                <div class="nk-block-head-content">
                                                    <h3 class="nk-block-title page-title">{{ translations.pilot }}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Pilot form -->
                                <div class="row gy-gs pb-3">

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[firstname]">{{ translations.forms.competitor.firstname }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[firstname]" name="pilot[firstname]" required="" v-model="pilot.firstname">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[lastname]">{{ translations.forms.competitor.lastname }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[lastname]" name="pilot[lastname]" required="" v-model="pilot.lastname">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[email]">{{ translations.forms.competitor.email }}</label>
                                            <div class="form-control-wrap">
                                                <input type="email" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[email]" name="pilot[email]" required="" v-model="pilot.email">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="pilot[resident]">{{ translations.forms.competitor.resident }}&nbsp;<em class="icon ni ni-help text-info" tabindex="0" data-toggle="tooltip" data-placement="top" :title="translations.forms.competitor.resident_tooltip_info"></em></label>
                                            <div class="g">
                                                <div class="custom-control custom-control-sm custom-checkbox">
                                                    <input type="checkbox" value="true" class="custom-control-input" id="pilot[resident]" v-model="pilot.resident">
                                                    <label class="custom-control-label" for="pilot[resident]"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="pilot[female]">{{ translations.forms.competitor.female }}</label>
                                            <div class="g">
                                                <div class="custom-control custom-control-sm custom-checkbox">
                                                    <input type="checkbox" value="true" class="custom-control-input" id="pilot[female]" v-model="pilot.female">
                                                    <label class="custom-control-label" for="pilot[female]"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[street]">{{ translations.forms.competitor.street }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[street]" name="pilot[street]" required="" v-model="pilot.street">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[number]">{{ translations.forms.competitor.number }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[number]" name="pilot[number]" required="" v-model="pilot.number">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[zipcode]">{{ translations.forms.competitor.zipcode }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[zipcode]" name="pilot[zipcode]" required="" v-model="pilot.zipcode">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[city]">{{ translations.forms.competitor.city }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[city]" name="pilot[city]" required="" v-model="pilot.city">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[country]">{{ translations.forms.competitor.country }}</label>
                                            <div class="form-control-wrap">
                                                <div class="form-control-select">
                                                    <select class="form-control" id="pilot[country]" name="pilot[country]" v-model="pilot.country">
                                                        <option v-for="(countryObject, index) in countries" :value="countryObject.code">{{ countryObject.translations[current_locale]['common'] }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[nationality]">{{ translations.forms.competitor.nationality }}</label>
                                            <div class="form-control-wrap">
                                                <div class="form-control-select">
                                                    <select class="form-control" id="pilot[nationality]" name="pilot[nationality]" v-model="pilot.nationality">
                                                        <option v-for="(demonym, code) in demonyms[current_locale]" :value="code">{{ demonym }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[language]">{{ translations.forms.competitor.language }}</label>
                                            <div class="form-control-wrap">
                                                <div class="form-control-select">
                                                    <select class="form-control" id="pilot[language]" name="pilot[language]" v-model="pilot.language">
                                                        <option v-for="(attributes, locale) in languages" :value="locale">{{ attributes.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <label class="form-label">{{ translations.forms.competitor.mobile_number }}</label>
                                        <div class="row">
                                            <div class="col-4">
                                                <div class="form-group" style="margin-top: -31px;">
                                                    <label class="form-label" for="pilot[mobile_iso_code]">&nbsp;</label>
                                                    <div class="form-control-wrap">
                                                        <div class="form-control-select">
                                                            <select class="form-control" id="pilot[mobile_iso_code]" name="pilot[mobile_iso_code]" v-model="pilot.mobile_iso_code">
                                                                <option v-for="prefix in phone_number_prefixes" :value="prefix">{{ prefix }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-8">
                                                <div class="form-group" style="margin-top: -31px;">
                                                    <label class="form-label" for="pilot[mobile_number]">&nbsp;</label>
                                                    <div class="form-control-wrap">
                                                        <input type="number" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[mobile_number]" name="pilot[mobile_number]" required="" v-model="pilot.mobile_number">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="row gy-gs pb-3">
                                    <div class="col-12">
                                        <h4>{{ translations.forms.misc.vas }}</h4>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label for="pilot[no_day_license]">{{ translations.forms.competitor.license }}</label>
                                            <div class="g">
                                                <div class="custom-control custom-control-sm custom-checkbox">
                                                    <input type="radio" value="0" class="custom-control-input" id="pilot[no_day_license]" v-model="pilot.day_license">
                                                    <label class="custom-control-label" for="pilot[no_day_license]"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label for="pilot[day_license]">{{ translations.forms.competitor.day_license }}</label>
                                            <div class="g">
                                                <div class="custom-control custom-control-sm custom-checkbox">
                                                    <input type="radio" value="1" class="custom-control-input" id="pilot[day_license]" v-model="pilot.day_license">
                                                    <label class="custom-control-label" for="pilot[day_license]"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-12" v-if="parseInt(pilot.day_license) === 0">
                                        <div class="row">
                                            <div class="col-lg-6 col-xs-12">
                                                <div class="form-group">
                                                    <label class="form-label" for="pilot[license_number]">{{ translations.forms.competitor.license_number }}</label>
                                                    <div class="form-control-wrap">
                                                        <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[license_number]" name="pilot[license_number]" required="" v-model="pilot.license_number">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-xs-12">
                                                <div class="form-group">
                                                    <label class="form-label" for="pilot[club]">{{ translations.forms.competitor.club }}</label>
                                                    <div class="form-control-wrap">
                                                        <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="pilot[club]" name="pilot[club]" required="" v-model="pilot.club">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div class="row gy-gs pb-3">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="form-label" for="pilot[license_or_eid]">{{ translations.forms.competitor.eid_or_license }}</label>
                                            <vue-dropzone ref="pilot[license_or_eid]" id="pilot[license_or_eid]" name="pilot[license_or_eid]" :options="dropzoneOptionsPilot"></vue-dropzone>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>

                            <tab-content :title="translations.copilot" icon="ni ni-user">
                                <!-- Co-pilot -->
                                <div class="row gy-gs pb-3">
                                    <div class="col">
                                        <div class="nk-block-head nk-block-head-sm">
                                            <div class="nk-block-between">
                                                <div class="nk-block-head-content">
                                                    <h3 class="nk-block-title page-title">{{ translations.copilot }}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Co-pilot form -->
                                <div class="row gy-gs pb-3">

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[firstname]">{{ translations.forms.competitor.firstname }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[firstname]" name="copilot[firstname]" required="" v-model="copilot.firstname">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[lastname]">{{ translations.forms.competitor.lastname }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[lastname]" name="copilot[lastname]" required="" v-model="copilot.lastname">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[email]">{{ translations.forms.competitor.email }}</label>
                                            <div class="form-control-wrap">
                                                <input type="email" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[email]" name="copilot[email]" required="" v-model="copilot.email">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label class="font-weight-bolder" for="copilot[resident]">{{ translations.forms.competitor.resident }}&nbsp;<em class="icon ni ni-help text-info" tabindex="0" data-toggle="tooltip" data-placement="top" :title="translations.forms.competitor.resident_tooltip_info"></em></label>
                                            <div class="g">
                                                <div class="custom-control custom-control-sm custom-checkbox">
                                                    <input type="checkbox" value="true" class="custom-control-input" id="copilot[resident]" v-model="copilot.resident">
                                                    <label class="custom-control-label" for="copilot[resident]"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="copilot[female]">{{ translations.forms.competitor.female }}</label>
                                            <div class="g">
                                                <div class="custom-control custom-control-sm custom-checkbox">
                                                    <input type="checkbox" value="true" class="custom-control-input" id="copilot[female]" v-model="copilot.female">
                                                    <label class="custom-control-label" for="copilot[female]"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[street]">{{ translations.forms.competitor.street }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[street]" name="copilot[street]" required="" v-model="copilot.street">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[number]">{{ translations.forms.competitor.number }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[number]" name="copilot[number]" required="" v-model="copilot.number">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[zipcode]">{{ translations.forms.competitor.zipcode }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[zipcode]" name="copilot[zipcode]" required="" v-model="copilot.zipcode">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[city]">{{ translations.forms.competitor.city }}</label>
                                            <div class="form-control-wrap">
                                                <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[city]" name="copilot[city]" required="" v-model="copilot.city">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-2 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[country]">{{ translations.forms.competitor.country }}</label>
                                            <div class="form-control-wrap">
                                                <div class="form-control-select">
                                                    <select class="form-control" id="copilot[country]" name="copilot[country]" v-model="copilot.country">
                                                        <option v-for="(countryObject, index) in countries" :value="countryObject.code">{{ countryObject.translations[current_locale]['common'] }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[nationality]">{{ translations.forms.competitor.nationality }}</label>
                                            <div class="form-control-wrap">
                                                <div class="form-control-select">
                                                    <select class="form-control" id="copilot[nationality]" name="copilot[nationality]" v-model="copilot.nationality">
                                                        <option v-for="(demonym, code) in demonyms[current_locale]" :value="code">{{ demonym }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[language]">{{ translations.forms.competitor.language }}</label>
                                            <div class="form-control-wrap">
                                                <div class="form-control-select">
                                                    <select class="form-control" id="copilot[language]" name="copilot[language]" v-model="copilot.language">
                                                        <option v-for="(attributes, locale) in languages" :value="locale">{{ attributes.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <label class="form-label">{{ translations.forms.competitor.mobile_number }}</label>
                                        <div class="row">
                                            <div class="col-4">
                                                <div class="form-group" style="margin-top: -31px;">
                                                    <label class="form-label" for="copilot[mobile_iso_code]">&nbsp;</label>
                                                    <div class="form-control-wrap">
                                                        <div class="form-control-select">
                                                            <select class="form-control" id="copilot[mobile_iso_code]" name="copilot[mobile_iso_code]" v-model="copilot.mobile_iso_code">
                                                                <option v-for="prefix in phone_number_prefixes" :value="prefix">{{ prefix }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-8">
                                                <div class="form-group" style="margin-top: -31px;">
                                                    <label class="form-label" for="copilot[mobile_number]">&nbsp;</label>
                                                    <div class="form-control-wrap">
                                                        <input type="number" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[mobile_number]" name="copilot[mobile_number]" required="" v-model="copilot.mobile_number">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div class="row gy-gs pb-3">
                                    <div class="col-12">
                                        <h4>{{ translations.forms.misc.vas }}</h4>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label for="copilot[no_day_license]">{{ translations.forms.competitor.license }}</label>
                                            <div class="g">
                                                <div class="custom-control custom-control-sm custom-checkbox">
                                                    <input type="radio" value="0" class="custom-control-input" id="copilot[no_day_license]" v-model="copilot.day_license">
                                                    <label class="custom-control-label" for="copilot[no_day_license]"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-xs-12">
                                        <div class="form-group">
                                            <label for="copilot[day_license]">{{ translations.forms.competitor.day_license }}</label>
                                            <div class="g">
                                                <div class="custom-control custom-control-sm custom-checkbox">
                                                    <input type="radio" value="1" class="custom-control-input" id="copilot[day_license]" v-model="copilot.day_license">
                                                    <label class="custom-control-label" for="copilot[day_license]"></label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-12" v-if="parseInt(copilot.day_license) === 0">
                                        <div class="row">
                                            <div class="col-lg-6 col-xs-12">
                                                <div class="form-group">
                                                    <label class="form-label" for="copilot[license_number]">{{ translations.forms.competitor.license_number }}</label>
                                                    <div class="form-control-wrap">
                                                        <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[license_number]" name="copilot[license_number]" required="" v-model="copilot.license_number">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-6 col-xs-12">
                                                <div class="form-group">
                                                    <label class="form-label" for="copilot[club]">{{ translations.forms.competitor.club }}</label>
                                                    <div class="form-control-wrap">
                                                        <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="copilot[club]" name="copilot[club]" required="" v-model="copilot.club">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div class="row gy-gs pb-3">
                                    <div class="col">
                                        <div class="form-group">
                                            <label class="form-label" for="copilot[license_or_eid]">{{ translations.forms.competitor.eid_or_license }}</label>
                                            <vue-dropzone ref="copilot[license_or_eid]" id="copilot[license_or_eid]" name="copilot[license_or_eid]" :options="dropzoneOptionsCopilot"></vue-dropzone>
                                        </div>
                                    </div>
                                </div>
                            </tab-content>

                            <tab-content :title="translations.vehicle" icon="fas fa-car mt-19">
                                <!-- Vehicle -->
                                <div class="row gy-gs pb-3">
                                    <div class="col">
                                        <div class="nk-block-head nk-block-head-sm">
                                            <div class="nk-block-between">
                                                <div class="nk-block-head-content">
                                                    <h3 class="nk-block-title page-title">{{ translations.vehicle }}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Vehicle form -->
                                <div class="row gy-gs pb-3">

                                <div class="col-lg-4 col-xs-12">
                                    <div class="form-group">
                                        <label class="form-label" for="vehicle[brand]">{{ translations.forms.vehicle.brand }}</label>
                                        <div class="form-control-wrap">
                                            <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="vehicle[brand]" name="vehicle[brand]" required="" v-model="vehicle.brand">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-xs-12">
                                    <div class="form-group">
                                        <label class="form-label" for="vehicle[type]">{{ translations.forms.vehicle.type }}</label>
                                        <div class="form-control-wrap">
                                            <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="vehicle[type]" name="vehicle[type]" required="" v-model="vehicle.type">
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-xs-12">
                                    <label class="form-label">{{ translations.forms.vehicle.build_year }}</label>
                                    <div class="form-group" style="margin-top: -31px;">
                                        <label class="form-label" for="vehicle[build_year]">&nbsp;</label>
                                        <div class="form-control-wrap">
                                            <div class="form-control-select">
                                                <select class="form-control" id="vehicle[build_year]" name="vehicle[build_year]" required v-model="vehicle.build_year">
                                                    <option v-for="year in years" :value="year">{{ year }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

<!--                                <div class="col-lg-6 col-xs-12">-->
<!--                                    <div class="form-group">-->
<!--                                        <label class="form-label" for="vehicle[chassis_number]">{{ translations.forms.vehicle.chassis_number }}</label>-->
<!--                                        <div class="form-control-wrap">-->
<!--                                            <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="vehicle[chassis_number]" name="vehicle[chassis_number]" required="" v-model="vehicle.chassis_number">-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label class="form-label" for="vehicle[license_plate]">{{ translations.forms.vehicle.license_plate }}</label>
                                        <span class="form-note">Format: 1-ABC-123</span>
                                        <div class="form-control-wrap">
                                            <input type="text" :data-msg="translations.forms.messages.required" class="form-control required" id="vehicle[license_plate]" name="vehicle[license_plate]" required="" v-model="vehicle.license_plate">
                                        </div>
                                    </div>
                                </div>


                            </div>
                            </tab-content>

                            <tab-content :title="translations.difficulty" icon="ni ni-star">
                                <!-- difficulty -->
                                <div class="row gy-gs pb-3">
                                <div class="col">

                                    <div class="nk-block-head nk-block-head-sm">
                                        <div class="nk-block-between">
                                            <div class="nk-block-head-content">
                                                <h3 class="nk-block-title page-title">{{ translations.difficulty }}</h3>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="difficulties.length">
                                        <!-- List the difficulties here -->
                                        <div class="row g-gs pb-3">
                                            <div
                                                class="col-sm-6 col-lg-4 col-xxl-3"
                                                v-for="(difficulty, index) in difficulties"
                                                :key="difficulty.place"
                                            >
                                                <div class="card card-bordered" style="min-height: 235px;max-height: 235px;">
                                                    <div class="card-inner">
                                                        <div class="team">
                                                            <div class="team-status bg-light text-black">
                                                                <em class="icon ni ni-check-thick"></em>
                                                            </div>
                                                            <div class="user-card user-card-s2">
                                                                <div class="user-info">
                                                                    <h6>{{ difficulty.title }}</h6>
                                                                </div>
                                                            </div>
                                                            <div class="team-details">
                                                                <p>{{ difficulty.description }}</p>
                                                            </div>
                                                            <div class="team-view mt-3">
                                                                <a href="javascript:void(0)"
                                                                   class="btn btn-round btn-outline-light w-150px"
                                                                   @click="selectDifficulty($event, difficulty)">
                                                                    <span>{{ translations.select }}</span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="row g-gs pb-3">
                                            <p>{{ translations.difficulties_empty }}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            </tab-content>

                            <tab-content v-if="event_catering.length" :title="translations.catering" icon="ni ni-coffee">
                                <!-- catering -->
                                <div class="row gy-gs pb-3">
                                    <div class="col">

                                        <div class="nk-block-head nk-block-head-sm">
                                            <div class="nk-block-between">
                                                <div class="nk-block-head-content">
                                                    <h3 class="nk-block-title page-title">{{ translations.catering }}</h3>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="event_catering.length">
                                            <!-- List the catering items here -->
                                            <div class="row g-gs pb-3">
                                                <div
                                                    class="col-sm-6 col-lg-4 col-xxl-3"
                                                    v-for="(catering, index) in event_catering"
                                                    :key="catering.id"
                                                >
                                                    <div class="card card-bordered">

                                                        <img v-if="catering.imageUrl !== ''" :src="catering.imageUrl"
                                                             class="card-img-top"
                                                             style="max-height: 158px;min-height: 158px;object-fit: cover;"
                                                             :alt="catering.name">

                                                        <div class="card-inner">
                                                            <div class="team">

                                                                <div class="user-card user-card-s2">
                                                                    <div class="user-info">
                                                                        <h6>{{ catering.name }}</h6>
                                                                        <small
                                                                            v-html="formatPrice(catering.sell_price) + '/pp.'"></small>
                                                                    </div>
                                                                </div>
                                                                <div class="team-details">
                                                                    <p>{{ catering.description }}</p>
                                                                    <div class="form-group">
                                                                        <label
                                                                            class="form-label"
                                                                            v-text="translations.forms.catering.select_amount"
                                                                        ></label>
                                                                        <div class="form-control-wrap">
                                                                            <div class="form-control-select">
                                                                                <select
                                                                                    :name="'catering[' + catering.id + '][]'"
                                                                                    class="form-control catering-selector"
                                                                                    v-model="cateringItems[catering.id]"
                                                                                    @change="updateSelectedCateringPrice"
                                                                                >
                                                                                    <option
                                                                                        v-for="amount in 3"
                                                                                        :key="(amount - 1)"
                                                                                        :data-catering="JSON.stringify(catering)"
                                                                                        :value="(amount - 1)"
                                                                                    >{{ (amount - 1) }}</option>
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </tab-content>

                            <tab-content :title="translations.legal" icon="ni ni-shield-star">

                                <div class="row gy-gs pb-3">
                                    <div class="col">
                                        <div class="nk-block-head nk-block-head-sm">
                                            <div class="nk-block-between">
                                                <div class="nk-block-head-content">
                                                    <h3 class="nk-block-title page-title">{{ translations.legal }}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row gy-gs pb-3">
                                    <div class="col">

                                        <div class="custom-control custom-checkbox">
                                            <input v-model="free_registration_form" type="checkbox" class="custom-control-input" id="freeRegistration">
                                            <label class="custom-control-label" for="freeRegistration" v-html="translations.forms.legal.free_registration"></label>
                                        </div>

                                    </div>
                                </div>

                                <!-- Free registration input validator -->
                                <div v-if="free_registration_form">
                                    <div class="row gy-gs pb-3">
                                        <div class="col">
                                            <div class="form-group">
                                                <label class="form-label" for="free_registration_code">{{ translations.forms.legal.free_registration_code }}</label>

                                                <div class="form-control-wrap">
                                                    <div class="form-icon form-icon-right">
                                                        <em id="free_registration_icon" class="icon ni" style="margin-right: 5rem;z-index: 1;"></em>
                                                    </div>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control" id="free_registration_code" v-model="free_registration_code" v-on:blur="checkFreeRegistrationCode">
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-primary btn-dim" id="free_registration_check_button" v-on:click="checkFreeRegistrationCode">Check</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row gy-gs pb-3">
                                    <div class="col">

                                        <div class="custom-control custom-checkbox">
                                            <input v-model="registration_terms_checked" type="checkbox" class="custom-control-input" id="termsAndConditions">
                                            <label class="custom-control-label" for="termsAndConditions" v-html="translations.forms.legal.accept_terms"></label>
                                        </div>

                                    </div>
                                </div>

                                <div class="row gy-gs pb-3">
                                    <div class="col">

                                        <div class="custom-control custom-checkbox">
                                            <input v-model="registration_event_rules_checked" type="checkbox" class="custom-control-input" id="event_rules">
                                            <label class="custom-control-label" for="event_rules" v-html="translations.forms.legal.accept_event_rules"></label>
                                        </div>

                                    </div>
                                </div>

                                <div class="row gy-gs pb-3">
                                    <div class="col">

                                        <div class="form-group">
                                            <label class="form-label" for="extra-information" v-html="translations.forms.legal.extra_information"></label>
                                            <div class="form-control-wrap">
                                                <textarea v-model="registration_extra_information" class="form-control no-resize" id="extra-information" :placeholder="translations.forms.legal.extra_information_placeholder"></textarea>
                                            </div>
                                        </div>

                                    </div>
                                </div>

<!--                                <div class="row gy-gs pb-3">-->
<!--                                    <div class="col">-->

<!--                                        <div class="custom-control custom-checkbox">-->
<!--                                            <input v-model="create_account" type="checkbox" class="custom-control-input" id="accountCheckbox" value="1">-->
<!--                                            <label class="custom-control-label" for="accountCheckbox">{{ translations.forms.legal.create_account }}&nbsp;<em class="icon ni ni-help text-info" data-toggle="tooltip" data-placement="top" :title="translations.forms.legal.tooltip_info"></em></label>-->
<!--                                        </div>-->

<!--                                    </div>-->
<!--                                </div>-->

                                <!-- Create account form -->
                                <div v-if="create_account">
                                    <div class="row gy-gs pb-3">
                                        <div class="col">
                                            <div class="form-group">
                                                <label class="form-label" for="acc_firstname">{{ translations.forms.legal.firstname }}</label>
                                                <div class="form-control-wrap">
                                                    <input type="text" class="form-control" id="acc_firstname" v-model="user.firstname">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label class="form-label" for="acc_lastname">{{ translations.forms.legal.lastname }}</label>
                                                <div class="form-control-wrap">
                                                    <input type="text" class="form-control" id="acc_lastname" v-model="user.lastname">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row gy-gs pb-3">
                                        <div class="col">
                                            <div class="form-group">
                                                <label class="form-label" for="acc_email">{{ translations.forms.legal.email }}</label>
                                                <div class="form-control-wrap">
                                                    <input type="email" class="form-control" id="acc_email" v-model="user.email">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label class="form-label" for="acc_pass">{{ translations.forms.legal.password }}</label>
                                                <div class="form-control-wrap">
                                                    <input type="password" class="form-control" id="acc_pass" v-model="user.password">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </tab-content>

                            <template slot="finish">
                                <!-- Just empty, cuz we don't want a button -->
                                <span></span>
                            </template>

                        </form-wizard>

                    </div>
                </div>
            </div>

            <!-- THE PRICES SIDEBAR -->
            <div class="col-lg-3">
                <div class="card card-bordered sticky-top ml-lg-4 ml-xl-0">

                    <div class="nk-iv-wg4">
                        <div class="nk-iv-wg4-sub">
                            <h6 class="nk-iv-wg4-title title">{{ translations.sidebar.title }}</h6>
                        </div>
<!--                        <div class="nk-iv-wg4-sub">-->
<!--                            <ul class="nk-iv-wg4-list">-->
<!--                                <li>-->
<!--                                    <div class="sub-text">{{ translations.sidebar.payment_method }}</div>-->
<!--                                    <div class="lead-text">{{ translations.sidebar.payment_method_value }}</div>-->
<!--                                </li>-->
<!--                            </ul>-->
<!--                        </div>-->
                        <div class="nk-iv-wg4-sub">
                            <ul class="nk-iv-wg4-list">
                                <li>
                                    <div class="sub-text">{{ translations.sidebar.registration }}</div>
                                    <div :class="{'striked': free_registration}" class="lead-text" v-html="formatPrice(event.price)"></div>
                                </li>
                                <li>
                                    <div class="sub-text">{{ translations.sidebar.day_license_pilot }}</div>
                                    <div class="lead-text" v-html="formatPrice(this.getPilotDayLicensePrice)"></div>
                                </li>
                                <li>
                                    <div class="sub-text">{{ translations.sidebar.day_license_copilot }}</div>
                                    <div class="lead-text" v-html="formatPrice(this.getCopilotDayLicensePrice)"></div>
                                </li>
                                <li v-if="event_catering.length">
                                    <div class="sub-text">{{ translations.sidebar.catering }}</div>
                                    <div class="lead-text" v-html="formatPrice(this.getCateringPrice)"></div>
                                </li>
                            </ul>
                        </div>
                        <div class="nk-iv-wg4-sub">
                            <ul class="nk-iv-wg4-list">
                                <li>
                                    <div class="lead-text">{{ translations.sidebar.total_amount }}</div>
                                    <div class="caption-text text-primary" v-html="formatPrice(getTotalAmountToPay)"></div>
                                </li>
                            </ul>
                        </div>
                        <div class="nk-iv-wg4-sub text-center bg-lighter">
                            <button
                               class="btn btn-lg btn-primary ttu"
                               :class="getCanContinueToPayment"
                               :disabled="disabledContinueToPaymentButton"
                               @click="validateFormAndCreatePayment($event)">
                                <span class="spinner-border spinner-border-sm d-none" role="status" aria-hidden="true"></span>
                                <span>{{ translations.sidebar.config_and_proceed }}</span>
                            </button>

                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

</template>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    .striked {
        text-decoration: line-through;
    }
</style>

<script>

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

Dropzone.autoDiscover = false;

export default {
    name: 'publicRegistrationForm',

    props: [
        'difficulties',
        'event_catering',
        'event',
        'phone_number_prefixes',
        'languages',
        'countries',
        'demonyms',
        'current_locale',
        'translations',
        'terms_url',
        'privacy_url',
        'event_rules_url',
    ],

    components: {
        vueDropzone: vue2Dropzone,
        FormWizard,
        TabContent
    },

    data() {
        return {
            pilot: {},
            copilot: {},
            vehicle: {},
            user: {},
            difficulty: 'None',
            registration_terms_checked: false,
            registration_event_rules_checked: false,
            registration_extra_information: null,
            create_account: false,
            free_registration: false,
            free_registration_form: false,
            free_registration_code: null,
            cateringItems: {},
            cateringPrice: 0.0,

            dropzoneOptionsPilot: {
                url: '/api/internal/events/registration/pilot/eid',
                thumbnailWidth: 150,
                maxFilesize: 4,
                uploadMultiple: false,
                maxFiles: 4,
                acceptedFiles: 'image/*',
                autoQueue: true,
                autoProcessQueue: true,
                headers: {
                    "Dotride-Session-Id": SESSION_ID
                }
            },
            dropzoneOptionsCopilot: {
                url: '/api/internal/events/registration/copilot/eid',
                thumbnailWidth: 150,
                maxFilesize: 4,
                uploadMultiple: false,
                maxFiles: 4,
                acceptedFiles: 'image/*',
                autoQueue: true,
                autoProcessQueue: true,
                headers: {
                    "Dotride-Session-Id": SESSION_ID
                }
            }
        }
    },

    computed: {
        getCateringPrice() {
            return this.cateringPrice
        },

        getPilotDayLicensePrice() {
            if (!this.pilot) {
                return 0
            }

            return parseInt(this.pilot?.day_license) === 1 ? this.event.day_license_price : 0.0
        },
        getCopilotDayLicensePrice() {
            if (!this.copilot) {
                return 0
            }

            return parseInt(this.copilot?.day_license) === 1 ? this.event.day_license_price : 0.0
        },

        getCanContinueToPayment: function () {
            return {
                disabled: !this.pilot || !this.copilot || this.difficulty === 'None' || !this.registration_terms_checked || !this.registration_event_rules_checked
                // disabled: false
            }
        },

        disabledContinueToPaymentButton: function () {
            return !this.pilot || !this.copilot || this.difficulty === 'None' || !this.registration_terms_checked || !this.registration_event_rules_checked
        },

        getTotalAmountToPay() {
            let eventPrice = this.event.price;
            if (this.free_registration) {
                eventPrice = 0;
            }
            return eventPrice + this.getPilotDayLicensePrice + this.getCopilotDayLicensePrice + this.getCateringPrice
        },

        years() {
            const year = new Date().getFullYear()
            return Array.from({length: year - 1899}, (value, index) => 1900 + index).reverse()
        }
    },

    mounted() {
        if (this.event_catering.length) {
            this.fillCateringToBeZero()
        }

        // Modify the links to work with the correct items
        this.translations.forms.legal.accept_terms = this.translations.forms.legal.accept_terms.replace('[url]', this.terms_url)
        this.translations.forms.legal.accept_terms = this.translations.forms.legal.accept_terms.replace('[url2]', this.privacy_url)
        this.translations.forms.legal.accept_event_rules = this.translations.forms.legal.accept_event_rules.replace('[url]', this.event_rules_url)

    },

    methods: {
        formatPrice(value, negativeAmount = false) {
            let val = (value / 1).toFixed(2).replace('.', ',')

            let response = '&euro; ';

            if (negativeAmount) {
                response += '- ';
            }

            response += val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')

            return response
        },

        fillCateringToBeZero() {
            let object = {}
            this.event_catering.forEach((cateringItem) => {
                // this.cateringItems = Object.assign(this.cateringItems, { [cateringItem.id]: 0 })
                object[cateringItem.id] = 0;
            })
            this.cateringItems = Object.create(object)
        },

        selectDifficulty(e, difficulty) {
            // Reset all the statuses of the visuals to be not checked
            $(e.currentTarget).parents().eq(5).find('.team-status').removeClass('bg-success')
                .removeClass('text-white')
                .addClass('bg-light')
                .addClass('text-black')

            $(e.currentTarget).parents().eq(1).find('.team-status')
                .removeClass('bg-light').removeClass('text-black')
                .addClass('bg-success').addClass('text-white')

            // Update the property
            this.difficulty = difficulty.title;
        },

        updateSelectedCateringPrice() {
            let total = 0.0;
            $('select.catering-selector').each(function () {
                let selectedValue = $(this).find('option:selected').val(),
                    cateringItem = $(this).find('option:selected').data('catering')

                total += (cateringItem.sell_price * selectedValue)
            })

            this.cateringPrice = total;
        },

        validateStep(stepName) {
            return true; // continue

            // stepName should always start like the inputs

            // return false; // Prevent next step
        },

        checkFreeRegistrationCode() {

            axios.post('/api/internal/events/registration/validate-free-registration', {
                code: this.free_registration_code,
                event_id: this.event.id
            }).then((response) => {
                if (response.data.length) {
                    if (response.data === "true") {
                        this.free_registration = true;
                        $('input#freeRegistration').attr('disabled', 'disabled').addClass('disabled');
                        $('#free_registration_check_button').attr('disabled', 'disabled').addClass('disabled');
                        $('input#free_registration_code').attr('disabled', 'disabled').addClass('disabled');
                        $('#free_registration_icon').removeClass('ni-cross text-danger').addClass('ni-check text-success');
                        NioApp.Toast('Code will be applied after proceeding to payment', 'success', { position: 'top-right', timeOut: 5000 });
                    } else {
                        this.free_registration = false;
                        $('input#freeRegistration').removeAttr('disabled').removeClass('disabled');
                        $('#free_registration_check_button').removeAttr('disabled').removeClass('disabled');
                        $('input#free_registration_code').removeAttr('disabled').removeClass('disabled');
                        $('#free_registration_icon').addClass('ni-cross text-danger').removeClass('ni-check text-success');

                        NioApp.Toast('Invalid code', 'info', { position: 'top-right', timeOut: 5000 });
                    }
                } else {
                    NioApp.Toast('Internal Server error - please contact us', 'error', { position: 'top-right', timeOut: 5000 });
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 429) {
                        NioApp.Toast('You tried too many wrong codes. This function is now locked', 'error', { position: 'top-right', timeOut: 5000 });
                    } else if (error.response.status === 500) {
                        NioApp.Toast('Internal Server error - please contact us', 'error', { position: 'top-right', timeOut: 5000 });
                    }
                }
            })

        },

        validateFormAndCreatePayment(e) {
            e.preventDefault()

            let submitButton = $(e.currentTarget);

            submitButton.find('.spinner-border').removeClass('d-none') // enable spinner
            submitButton.attr('disabled', 'disabled') // disable button
            submitButton.addClass('disabled') // disable button

            // do API call to store the items
            axios.post('/api/internal/events/registration/register', {
                event: this.event,
                pilot: this.pilot,
                copilot: this.copilot,
                vehicle: this.vehicle,
                difficulty: this.difficulty,
                cateringItems: this.cateringItems,
                user: this.user,
                create_user: this.create_account,
                session_id: SESSION_ID,
                language: this.current_locale,
                free_registration_code: this.free_registration_code,
                extra_information: this.registration_extra_information,
            }).then((response) => {
                // When the form validation was OK, then create the payment

                // check if the response has a payment URL to redirect to, if not, then we will show another modal and redirect to the registration
                // if (response.data.payment_url.length) {
                //     // Show payment modal and URL thing
                //     $('#modalInformPayment').modal({
                //         backdrop: 'static',
                //         keyboard: false
                //     })
                //
                //     $('.js__create-payment').on('click', (e) => {
                //         window.location.href = response.data.payment_url
                //     })
                // }
                //
                // if (response.data.redirect_url.length) {
                //     NioApp.Toast(response.data.success_message, 'success', { position: 'top-right', timeOut: 5000 });
                //     window.location.href = response.data.redirect_url
                // }

                if (response.data && response.data.redirect_url) {
                    window.location.href = response.data.redirect_url;
                }

                if (response.data.error.length) {
                    NioApp.Toast(response.data.error, 'error', { position: 'top-right', timeOut: 5000 });
                }

            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 422) {
                        // Loop over the errors
                        for (let key in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(key)) {
                                NioApp.Toast(error.response.data.errors[key][0], 'error', { position: 'top-right', timeOut: 5000 });
                            }
                        }
                    } else if (error.response.status === 500) {
                        NioApp.Toast('Internal Server error - please contact us', 'error', { position: 'top-right', timeOut: 5000 });
                    }

                    // re-enable the button
                    submitButton.find('.spinner-border').addClass('d-none') // disable spinner
                    submitButton.removeClass('disabled') // enable button
                    submitButton.removeAttr('disabled') // enable button
                }
            })

        },
    },
}

</script>
